<template>
    <div class="sayfayok">
        <h1 class="h1">Yetkisiz İşlem</h1>
        <router-link class="url" to="/panel">{{$t('Hata.10')}}</router-link>
    </div>
</template>

<script>
    export default {
        name: "SayfaYok"
    }
</script>

<style scoped>
    .sayfayok {
        background-image: url(../../assets/img/error-404.svg);
        position: fixed;
        z-index: 99999;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        top: 0;
        right: 0;
        background-position: center;
        text-align: center;
        padding-top: 10vh;
    }

    .h1 {
        text-shadow: 1px 1px 13px #fff;
        color: #de4337;
    }
    .url{}

</style>


// WEBPACK FOOTER //
// src/pages/spesiyal/Yetkisiz.vue